import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import IconSvg from "../../../../../../SharedComponents/IconSvg";
import { getApplicationBackup } from "../../../Store/Thunk";
import { AdminButton } from "../../../../../SharedComponents/ListView";

export default function BackUpButton({ inventory }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const Download = () => {
    dispatch(getApplicationBackup({ id: inventory.id, name: inventory.name }));
  };

  return (
    <AdminButton variant="outline" onClick={Download} title={t("backup")} aria-label={t("backup")}>
      <IconSvg icon="download" />
    </AdminButton>
  );
}
